import { IconButton } from "@/components/ui/button"
import { ArrowLeft } from "lucide-react"

interface NavHeaderProps {
  children: React.ReactNode
  actions?: React.ReactNode
  hideBackButton?: boolean
}

export const NavHeader = ({ children, actions, hideBackButton = false }: NavHeaderProps) => {
  return (
    <div className="flex items-center justify-between gap-4 mb-6">
      <div className="flex items-center gap-4">
        {!hideBackButton && (
          <IconButton
            variant="default"
            onClick={() => window.history.back()}>
            <ArrowLeft className="h-3.5 w-3.5" />
          </IconButton>
        )}
        <div>
          {children}
        </div>
      </div>
      {actions && (
        <div className="flex items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  )
}